import { img, PHOTO } from "#/lib/images";
import { CTAButton } from "#/components/shared/CTAButton";
import { SectionLabel } from "#/components/shared/SectionLabel";
import { useScrollAnimation } from "#/hooks/useScrollAnimation";
import { Check } from "lucide-react";

const BENEFITS = [
  "The look of stone, slate, brick, or wood",
  "Custom patterns & integral color",
  "A fraction of the cost of pavers",
  "Sealed to hold its color for years",
];

export function StampedShowcase() {
  const { ref, isVisible } = useScrollAnimation(0.1);

  return (
    <section className="relative overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0">
        <img
          src={img(PHOTO.showcase, { w: 1920, h: 1000 })}
          alt="Finished stamped concrete patio with a stone-look finish"
          width={1920}
          height={1000}
          loading="lazy"
          decoding="async"
          className="h-full w-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-graphite via-graphite/80 to-graphite/30" />
      </div>

      <div ref={ref} className="relative mx-auto max-w-7xl px-4 py-24 sm:px-6 lg:px-8 lg:py-32">
        <div className="max-w-xl">
          <SectionLabel tone="light">Our Specialty</SectionLabel>
          <h2
            className={`mt-4 font-heading text-3xl font-extrabold leading-[1.1] text-white transition-all duration-700 sm:text-4xl lg:text-5xl ${
              isVisible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"
            }`}
          >
            Stamped concrete that turns a slab into a centerpiece.
          </h2>
          <p
            className={`mt-5 leading-relaxed text-concrete-light transition-all delay-100 duration-700 ${
              isVisible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"
            }`}
          >
            Decorative concrete is where we shine. We'll match almost any high-end material at a
            fraction of the price, and seal it to survive Delaware seasons.
          </p>

          <ul
            className={`mt-7 grid gap-3 sm:grid-cols-2 transition-all delay-200 duration-700 ${
              isVisible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"
            }`}
          >
            {BENEFITS.map((b) => (
              <li key={b} className="flex items-start gap-2.5 text-sm text-white">
                <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-flame">
                  <Check className="h-3 w-3 text-white" strokeWidth={3} />
                </span>
                {b}
              </li>
            ))}
          </ul>

          <div
            className={`mt-9 transition-all delay-300 duration-700 ${
              isVisible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"
            }`}
          >
            <CTAButton
              href="/services#stamped-decorative-concrete"
              variant="flame-bubble"
              size="lg"
            >
              Explore Stamped &amp; Decorative
            </CTAButton>
          </div>
        </div>
      </div>
    </section>
  );
}
